import { PageComponent } from "barba"

class IsWithinClass {

    constructor({ node }) {
        this.node = node
        this.html = document.querySelector('html')

        this.classes = this.node.dataset.isWithin
        if (this.classes.trim() !== '') {
            this.classes = this.classes.replace(/\s+/g, " ")
        } else {
            this.classes = 'is-within'
        }
        this.classes = this.classes.split(' ')
        

        this.updateHandler = this.update.bind(this)

        this.html.addEventListener('click', this.updateHandler)
        this.html.addEventListener('focusin', this.updateHandler)
    }

    update(e) {
        const node = e.target.closest('[data-is-within]')
        const toggleNode = e.target.closest('[data-is-within-toggle]')
        const open = () => this.node.classList.add(...this.classes)
        const close = () => this.node.classList.remove(...this.classes)

        // Toggle on click
        if (e.type === 'click' && node === this.node && toggleNode && this.node.contains(toggleNode)) {
            this.isWithin() ? close() : open()
            return
        }

        // If target is inside
        this.node.contains(e.target) ? open() : close()
    }

    isWithin() {
        for (const c of this.classes) {
            if (!this.node.classList.contains(c)) return false
        }
        return true
    }

    destroy() {
        this.html.removeEventListener('click', this.updateHandler)
        this.html.removeEventListener('focusin', this.updateHandler)

        delete this.node
        delete this.html
        delete this.classes

        delete this.updateHandler
    }

}

new PageComponent("[data-is-within]", IsWithinClass)